import styled from "styled-components";

const Wrapper = styled.div`
  > div {
    height: auto;
    margin-bottom: 20px;
  }
`;

export default Wrapper
